import { buildAgentUrl } from '@/lib/agent/api';

const WORKSPACE_AGENT_PREFIX = '/workspace/agent';

/**
 * Resolve a media URL into something safe for browser rendering.
 *
 * Workspace-agent media URLs need to flow through buildAgentUrl() so
 * deployed workspaces get the correct origin and Envoy token. Other
 * media URLs are restricted to same-origin relative paths or HTTP(S).
 */
export function browserMediaUrl(url: string | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (!isWorkspaceAgentUrl(trimmed)) return isBrowserSafeMediaUrl(trimmed) ? trimmed : null;
  try {
    return buildAgentUrl(trimmed.slice(WORKSPACE_AGENT_PREFIX.length));
  } catch {
    return null;
  }
}

function isWorkspaceAgentUrl(url: string): boolean {
  return url === WORKSPACE_AGENT_PREFIX || url.startsWith(`${WORKSPACE_AGENT_PREFIX}/`);
}

function isBrowserSafeMediaUrl(url: string): boolean {
  if (url.startsWith('//')) return false;
  if (url.startsWith('/')) return true;
  return /^https?:\/\//i.test(url);
}
